import script from "./TalentCodePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentCodePanel.vue?vue&type=script&setup=true&lang=js"

import "./TalentCodePanel.vue?vue&type=style&index=0&id=659caed0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659caed0"]])

export default __exports__